import { useState } from 'react'
import { Alert, Button, Card, Group, Stack, Text, Title } from '@mantine/core'
import { notifications } from '@mantine/notifications'
import { IconInfoCircle, IconSettings2 } from '@tabler/icons-react'
import { Navigation } from './components'
import { useMiddlewareClient } from '@/hooks'

export function SuperHome() {
  const middleware = useMiddlewareClient()
  const [isLoading, setIsLoading] = useState(false)
  const [lastResult, setLastResult] = useState<{
    success?: boolean
    projectId?: string
    projectName?: string
  } | null>(null)

  const runProjectConfigure = async () => {
    try {
      setIsLoading(true)
      const response = await middleware.post('/super/project-configure')
      setLastResult(response)
      notifications.show({
        color: 'green',
        title: 'Project configured',
        message: `Configuration completed for ${response.projectName ?? 'project'}`,
      })
    } catch (error) {
      notifications.show({
        color: 'red',
        title: 'Configuration failed',
        message: (error as Error)?.message || 'Failed to configure project',
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <Navigation />
      <div className="px-6 py-4">
        <Title order={2} mb="md">
          Super Home
        </Title>

        <Stack gap="md" maw={820}>
          <Alert variant="light" icon={<IconInfoCircle size={18} />}>
            Run project bootstrap configuration directly from middleware. This endpoint is
            super-admin only.
          </Alert>

          <Card withBorder shadow="sm" radius="md" p="lg">
            <Stack gap="md">
              <Group justify="space-between" align="center">
                <div>
                  <Text fw={600}>Project Configure</Text>
                  <Text c="dimmed" size="sm">
                    Source: middleware super project configure pipeline
                  </Text>
                </div>
                <Button
                  leftSection={<IconSettings2 size={18} />}
                  loading={isLoading}
                  onClick={runProjectConfigure}
                >
                  Run Configure
                </Button>
              </Group>

              {lastResult && (
                <Text size="sm" c="dimmed">
                  Last run result: success `{String(lastResult.success ?? false)}`, project `
                  {lastResult.projectName ?? '-'}` (`{lastResult.projectId ?? '-'}`).
                </Text>
              )}
            </Stack>
          </Card>
        </Stack>
      </div>
    </>
  )
}
